import { useMutation } from '@tanstack/react-query'
import { track } from '@opallabs/api/v1'

export const useTrackActionMutation = () =>
  useMutation({ mutationFn: track.create })
